<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>contacts</md-icon>
                    </div>
                    <h4 class="title">Edit Signature</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to Profile
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Signature
                            </label>
                            <div class="md-layout-item">
                                <div class="file-input">
                                    <div v-if="image">
                                        <div class="image-container">
                                            <img :src="image" />
                                        </div>
                                    </div>
                                    <div class="image-container" v-else>
                                        <img :src="default_img" />
                                    </div>
                                    <div class="button-container">
                                        <md-button
                                                class="md-danger md-round"
                                                @click="removeImage"
                                                v-if="image"
                                        >
                                            <i class="fa fa-times" />
                                            Remove
                                        </md-button>
                                        <md-button class="md-success md-fileinput">
                                            <template v-if="!image">Select image</template>
                                            <template v-else>Change</template>
                                            <input type="file" @change="onFileChange" />
                                        </md-button>
                                    </div>
                                </div>
                                <md-field class="md-invalid">
                                    <validation-error :errors="apiValidationErrors.attachment" />
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Signature</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    name: 'edit-signature-card',
    components: { ValidationError },

    mixins: [formMixin],

    data () {
        return {
            user:{},
            image: null,
            default_img: process.env.VUE_APP_BASE_URL + '/img/placeholder.jpg',
            file: null,
        };
    },
    created () {
        this.getProfile();
    },
    methods: {

        async update () {
            console.log('mimi');
            console.log(this.user);

            try {
                this.resetApiValidation();
                if (this.file) {
                    await this.$store.dispatch('users/uploadsign', {
                        user: this.user,
                        image: this.file,
                    });

                    this.user.signature = await this.$store.getters['users/url'];
                    console.log('weew');
                    console.log(this.user);
                    await this.$store.dispatch('signature/update', this.user);
                    // console.log(this.user);
                }
                console.log(this.user);
                await this.$store.dispatch(
                    'alerts/success',
                    'Signature updated successfully.'
                );
                this.goBack();
                // await this.$store.getters["profile/me"];
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        async getProfile () {
            await this.$store.dispatch('profile/me');
            this.user = await this.$store.getters['profile/me'];
            //this.image = process.env.VUE_APP_IMG_URL + this.user.signature;
            this.image = this.user.signature_url;
        },
        onFileChange (e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },

        createImage (file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.image = e.target.result;
                this.file = file;
            };
            reader.readAsDataURL(file);
        },

        removeImage () {
            this.image = null;
        },

        goBack () {
            this.$router.push({ name: 'User Profile' });
        },
    },
};
</script>

<style lang="scss">
    .spacing {
        padding-bottom: 1rem;
    }
</style>
